(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabSchedule', TabSchedule);

    TabSchedule.$inject = ['$resource', 'DateUtils'];

    function TabSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/tab-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': { url: 'api/tab-schedules/search', method: 'POST', isArray: true}
        });
    }
})();
